export const environment = {
  production: false,
  productLogoLarge: 'assets/images/smart-menu-logo.svg',
  serverUrl: 'https://sm-api-gateway-service-dev.optimusai.ai/',
  // serverUrl: 'https://dev2.optimusai.ai/',
};
